export default class FooterHandler {
	init() {
		const footer = document.querySelector('footer');

		if (footer) {
			const previousSection = footer.previousElementSibling;
			const hasGlobalCta = footer.querySelector('[data-id="global_cta"]');

			if (previousSection && hasGlobalCta) {
				if (previousSection.classList.contains('pb-margins') || (previousSection.hasAttribute('data-margin-overlap') && previousSection.getAttribute('data-margin-overlap') === 'top')) {
					previousSection.classList.add('pb-overlap-2');
				} else {
					previousSection.classList.add('pb-overlap');
				}
			}

			// Remove mb-margins from section above footer if it exists
			if (previousSection && previousSection.tagName === 'SECTION') {
				if (previousSection.classList.contains('mb-margins')) {
					previousSection.classList.remove('mb-margins');
				}
			}
		}
	}
}